module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-a42740c1.png";